import { render } from "./PageTitle.vue?vue&type=template&id=480fedf8&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"

import "./PageTitle.vue?vue&type=style&index=0&id=480fedf8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-480fedf8"

export default script